<template>
  <p class="RwvContentHtml" v-html="html"></p>
</template>

<script>
export default {
  name: "RwvContentHtml",
  props: {
    html: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
